import {Text} from "@fluentui/react-components";
import {useRef} from "react";
import * as React from "react";
import Content from "../domain/Content";
import OrganizationPlaceholder from "../domain/OrganizationPlaceholder";
import ViewInfo from "../domain/ViewInfo";
import NewsfeedItem from "./NewsfeedItem";


export interface ISearchProps {
    searchViewInfo: ViewInfo;
    organizationPlaceholders: OrganizationPlaceholder[];
    organizationIcon?: string;
    onReadMore: (content: Content) => void;
    onDismiss: (content: Content) => void;
}
export default function Search (props: ISearchProps) {
    const currentPlaceholderIndex = useRef<number>(0);

    function getImage(content: Content) {
        let imageToUse: string = "";
        if (content && content.imageSrc && content.imageSrc.length > 0) {
            imageToUse = content.imageSrc;
        } else if (props.organizationPlaceholders && props.organizationPlaceholders.length > 0) {
            let targetIndex: number;
            const placeHolderLength: number = props.organizationPlaceholders.length;

            targetIndex = currentPlaceholderIndex.current;
            currentPlaceholderIndex.current++;
            if (currentPlaceholderIndex.current >= placeHolderLength) {
                currentPlaceholderIndex.current = 0;
            }

            imageToUse = props.organizationPlaceholders[targetIndex].imageSrc || "";

        }

        if (!imageToUse || imageToUse.length <= 0) {
            imageToUse = props.organizationIcon || "";
        }

        return imageToUse;
    }

    function render() {
        if (props.searchViewInfo.itemsToDisplay.length > 0 ) {
            const items= props.searchViewInfo.itemsToDisplay.map((curItem: Content) => {
                return (
                    <NewsfeedItem
                        content={curItem}
                        storyImage={getImage(curItem)}
                        key={"search" + curItem.postId}
                        onReadMore={ props.onReadMore }
                        onDismiss={ props.onDismiss  } />);
            });
            return (<React.Fragment>{items}</React.Fragment>);
        } else {
            let message = "Enter keyword and press enter to search";
            if (props.searchViewInfo.isPreloading) {
                message = `Searching...`;
            } else if (props.searchViewInfo.searchText && props.searchViewInfo.searchText.length > 0 && !props.searchViewInfo.isPreloading) {
                message = `No results for ${props.searchViewInfo.searchText}`;
            }
            return (
                <div className="smt-flex smt-flex__dir_column smt-filled smt-flex__jc-center smt-flex__ai-center">
                    <Text weight="semibold" size={500}>{message}</Text>
                </div>
            );
        }

    }
    return render();

}
